'use client';
import { SearchSidebar } from '@trwl/widgets/nav/search-sidebar';
import { NavigationSidebar } from '@trwl/widgets/nav/sidebar';

export const Sidebars = () => {
  return (
    <>
      <NavigationSidebar.Mount />
      <SearchSidebar.Mount />
    </>
  );
};
